import { FingerprintVaultSettings } from "./fingerprint-vault-settings";

export function FingerprintSyncSettings() { return <FingerprintVaultSettings />; }
